import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, Type } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreDirectivesModule } from '@app/directives/_core/_core.directives.module';
import { FormsDirectivesModule } from '@app/directives/_forms/_form.directives.module';
import { VTableModule } from '@app/directives/_layout/v-table/v-table.module';
import { GroupsModule } from '@app/main/components/resourceManagement/groups/groups.module';
import { ResourceManagementModule } from '@app/main/components/resourceManagement/resourceManagement.module';
import { RequestVideoFormComponent } from '@app/main/components/videos/requestVideo/request-video-form/request-video-form.component';
import { RequestVideoService } from '@app/main/components/videos/requestVideo/requestVideo.service';
import { RequestVideoActivityChartComponent } from "@app/main/components/videos/requestVideo/requestVideoActivityChart/request-video-activity-chart.component";
import { VideoChannelSelectorComponent } from '@app/main/components/videos/video-channel-selector/video-channel-selector.component';
import { CameraDisplayService } from "@components/videos/cameraDisplay.service";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MapDirectivesModule } from "@directives/_map/_map.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { VehicleDirectivesModule } from "@directives/_vehicle/_vehicle.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { ObservationsService } from "@services/observations.service";
import { providerCreator } from "@services/_services.module";
import { PipesModule } from 'src/app/_pipes/_pipes.module';
import { CameraSignalStrengthComponent } from "./_components/camera-signal-strength/camera-signal-strength.component";
import { DownloadQualitySelector } from './_components/download-quality-selector/download-quality-selector.component';
import { VideoAddressComponent } from "./_components/video-address/video-address.component";
import { VideoDownloadListComponent } from './_components/video-download-list/video-download-list.component';
import { VideoDownloadProgressComponent } from './_components/video-download-progress/video-download-progress.component';
import { VideoDriverAssignmentComponent } from './_components/video-driver-assignment/video-driver-assignment.component';
import { VideoEntryComponent } from "./_components/video-entry/video-entry.component";
import { VideoEventListComponent } from "./_components/video-event-list/video-event-list.component";
import { VideoListComponent } from "./_components/video-list/video-list.component";
import { VideoRequestStatusComponent } from './_components/video-request-status/video-request-status.component';

const privateComponents: Type<any>[] = [

];

const publicComponents: any[] = [
    VideoEntryComponent,
    VideoAddressComponent,
    VideoEventListComponent,
    VideoListComponent,
    VideoDownloadListComponent,
    VideoDownloadProgressComponent,
    VideoRequestStatusComponent,
    CameraSignalStrengthComponent,
    RequestVideoFormComponent,
    RequestVideoActivityChartComponent,
    VideoChannelSelectorComponent,
    DownloadQualitySelector,
    VideoDriverAssignmentComponent];

const declarations: Type<any>[] = [
];

const providers: any[] = [
    providerCreator(CameraDisplayService, "cameraDisplayService"),
    providerCreator(ObservationsService, "observationsService"),
    providerCreator(RequestVideoService, "requestVideoService"),
];

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        ScrollingModule,
        CoreDirectivesModule,
        HttpClientModule,
        BrowserAnimationsModule,
        PipesModule,
        VeriDirectivesModule,
        ResourceFiltersDirectivesModule, // for resource filters
        LayoutDirectivesModule, // for empty state
        VehicleDirectivesModule, //vehicle-reg
        MiscDirectivesModule, // loading indicator
        MapDirectivesModule,// for maps
        FormsDirectivesModule,
        VTableModule,
        ResourceManagementModule,
        GroupsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class CameraModule {
    constructor() {
    }
}
